export default __webpack_public_path__ + "static/media/third.66aa7a7e.svg";